var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.isOverview168)?_c(_setup.Overview168,{attrs:{"moduleData":_setup.props.moduleData}}):_c(_setup.Overview,{attrs:{"moduleData":_setup.props.moduleData}}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }